module.exports = __webpack_public_path__ + "static/media/close_password.0a55f7ed.svg";